module.exports = __webpack_public_path__ + "media/images/applicant/logo-iup-5cd56171ccd5fe7c1f34fffa812f067c.svg";